import { readStoredValue, writeStoredValue } from './storedValue'

const SELECTED_FARM_ID_KEY = 'selectedFarmId'
const USER_ROLE_SELECTED_KEY = 'userRoleSelected'

const listeners = new Set<() => void>()

const notify = () => {
  listeners.forEach(listener => listener())
}

// Seeded once and then owned in memory: a farm chosen in another tab must never move this tab's
// selection out from under work in progress, and the snapshot keeps useSyncExternalStore stable.
let selectedFarmId = readStoredValue(SELECTED_FARM_ID_KEY)
let userRoleSelected = readStoredValue(USER_ROLE_SELECTED_KEY)

export const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export const getSelectedFarmId = (): string | null => selectedFarmId

export const setSelectedFarmId = (farmId: string | null) => {
  selectedFarmId = farmId
  writeStoredValue(SELECTED_FARM_ID_KEY, farmId)
  notify()
}

export const getUserRoleSelected = (): string | null => userRoleSelected

export const setUserRoleSelected = (role: string | null) => {
  userRoleSelected = role
  writeStoredValue(USER_ROLE_SELECTED_KEY, role)
  notify()
}

export const clearAppPreferences = () => {
  selectedFarmId = null
  userRoleSelected = null
  writeStoredValue(SELECTED_FARM_ID_KEY, null)
  writeStoredValue(USER_ROLE_SELECTED_KEY, null)
  notify()
}
